'use strict'
export const apiUrl = '//testback-hitolog.n-links.biz'
export const authUrl = '//testauth.n-links.biz'
export const myUrl = 'testhitolog.n-links.biz'
export const appName = 'hitolog_test'



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 112